import Text from '../../Text/Text';

/**
 * DraftsTab component
 * Placeholder component for drafts functionality (to be implemented)
 */
export const DraftsTab = () => {
  return (
    <div className="flex items-center justify-center bg-background rounded-xl w-full min-h-[705px]">
      <Text size="lg" color="text-text-600">
        Rascunhos em desenvolvimento
      </Text>
    </div>
  );
};

export default DraftsTab;
